/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running a focused 15-minute reading sprint without checking your phone.`)
};

const es_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacer un sprint de lectura enfocado de 15 minutos sin revisar el teléfono.`)
};

const de_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen fokussierten 15-Minuten-Lesesprint machen, ohne aufs Handy zu schauen.`)
};

const nl_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een geconcentreerde leessprint van 15 minuten doen zonder op je telefoon te kijken.`)
};

const fr_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire un sprint de lecture concentré de 15 minutes sans consulter son téléphone.`)
};

const it_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare uno sprint di lettura concentrato di 15 minuti senza controllare il telefono.`)
};

const pt_br2_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um sprint de leitura focado de 15 minutos sem checar o celular.`)
};

const pt_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer um sprint de leitura focado de 15 minutos sem consultar o telemóvel.`)
};

const ja_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートフォンをチェックせずに集中した15分間の読書スプリントを行う。`)
};

const zh_timer_u15m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行一次专注的15分钟阅读冲刺，期间不看手机。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u15m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u15m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u15m_use2", locale)
	if (locale === "en") return en_timer_u15m_use2(inputs)
	if (locale === "es") return es_timer_u15m_use2(inputs)
	if (locale === "de") return de_timer_u15m_use2(inputs)
	if (locale === "nl") return nl_timer_u15m_use2(inputs)
	if (locale === "fr") return fr_timer_u15m_use2(inputs)
	if (locale === "it") return it_timer_u15m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u15m_use2(inputs)
	if (locale === "pt") return pt_timer_u15m_use2(inputs)
	if (locale === "ja") return ja_timer_u15m_use2(inputs)
	return zh_timer_u15m_use2(inputs)
};